import React from "react";
import {Helmet} from "react-helmet";
import PropTypes from "prop-types";

const seoBaseUrl = process.env.REACT_APP_SEO_BASE_URL;


const MainHelmet = (props) => (
    <Helmet defaultTitle={"envimate blog"} titleTemplate={"blog.envimate.com: %s"}>

        <title>{props.title}</title>
        <meta name="description"
              content={props.description}/>
        <meta name="title" content={props.title}/>
        <meta name="robots" content="index,follow"/>
        <meta name="googlebot" content="index,follow"/>
        <meta name="google" content="nositelinkssearchbox"/>
        <meta name="google" content="notranslate"/>
        <meta name="subject" content="envimate's official blog"/>
        <meta name="rating" content="General"/>
        <meta name="referrer" content="origin"/>
        <meta name="format-detection" content="telephone=no"/>
        <meta httpEquiv="x-dns-prefetch-control" content="off"/>
        <meta httpEquiv="Window-Target" content="_value"/>
        <meta property="og:type" content="website"/>
        <meta property="og:site_name" content="envimate blog"/>
        <meta property="og:locale" content="en"/>
            <meta name="parsely-link"
                  content={seoBaseUrl}/>

        <meta property="og:image:width" content="512"/>
        <meta property="og:image:height" content="512"/>

        <meta property="og:url" content={seoBaseUrl}/>
        <meta property="og:image" content={seoBaseUrl + props.image}/>
        <meta property="og:image:url" content={seoBaseUrl + props.image}/>
        <meta property="og:image:secure_url" content={seoBaseUrl + props.image}/>
        <meta property="og:image:alt" content={props.imageAlt}/>


        <meta name="twitter:card" content="summary_large_image"/>
        <meta name="twitter:site" content="@envimate"/>
        <meta name="twitter:creator" content={"@envimate"}/>
        <meta name="twitter:url" content={seoBaseUrl}/>
        <meta name="twitter:title" content={props.title}/>
        <meta name="twitter:description"
              content={props.description}/>
        <meta name="twitter:image" content={seoBaseUrl + props.image}/>
        <meta name="twitter:image:src" content={seoBaseUrl + props.image}/>
        <meta name="twitter:image:alt" content={props.imageAlt}/>


        <link rel="manifest" href={seoBaseUrl + "/manifest.json"}/>
        <base href={seoBaseUrl}/>

        <link rel="icon" href={seoBaseUrl + "/favicon.ico"}/>
        <link rel="icon" href={seoBaseUrl + "/favicons/favicon-16x16.png"} sizes="16x16" type="image/png"/>
        <link rel="icon" href={seoBaseUrl + "/favicons/favicon-32x32.png"} sizes="32x32" type="image/png"/>
        <link rel="icon" href={seoBaseUrl + "/favicons/favicon-64x64.png"} sizes="64x64" type="image/png"/>
        <link rel="icon" href={seoBaseUrl + "/favicons/favicon-128x128.png"} sizes="128x128" type="image/png"/>
        <link rel="icon" href={seoBaseUrl + "/favicons/favicon-256x256.png"} sizes="256x256" type="image/png"/>
        <link rel="apple-touch-icon" sizes="128x128" href={seoBaseUrl + "/favicons/apple-touch-icon.png"}/>
        <link rel="mask-icon" href={seoBaseUrl + "/favicons/favicon-256x256.png"} color="#F2385A"/>
        <meta name="msapplication-config" content={seoBaseUrl + "/browserconfig.xml"}/>

        <link rel="archives" href={seoBaseUrl}/>
        <link rel="index" href={seoBaseUrl}/>
        <link rel="sitemap" type="application/xml" href={seoBaseUrl + "/sitemap.xml"}/>
    </Helmet>);

const SingleArticleHelmet = (props) => (
    <Helmet>
        <title>{props.header}</title>
        <meta name="title" content={props.header}/>
        <meta name="author" content={props.author}/>
        <link rel="canonical" href={seoBaseUrl + props.relativePath}/>
        <meta name="description" content={props.summary}/>

            <meta name="parsely-link"
                  content={seoBaseUrl + props.relativePath}/>

        <meta property="og:url" content={seoBaseUrl + props.relativePath}/>
        <meta property="og:title" content={props.header}/>
        <meta property="og:image" content={seoBaseUrl + props.image}/>
        <meta property="og:image:url" content={seoBaseUrl + props.image}/>
        <meta property="og:image:secure_url" content={seoBaseUrl + props.image}/>
        <meta property="og:image:alt" content={props.imageAlt}/>
        <meta property="og:description" content={props.summary}/>
        <meta property="article:author" content={props.author}/>
        <meta property="article:publisher" content="https://envimate.com"/>

        <meta name="article:published_time" content={props.date}/>


        <meta property="og:type" content="article"/>

        <meta name="twitter:label1" content="Reading time"/>
        <meta name="twitter:data1" content={props.readTime}/>
        <meta name="twitter:card" content="summary_large_image"/>
        <meta name="twitter:site" content="@envimate"/>
        <meta name="twitter:creator" content={"@" + props.author}/>
        <meta name="twitter:url" content={seoBaseUrl + props.relativePath}/>
        <meta name="twitter:title" content={props.header}/>
        <meta name="twitter:description" content={props.shortSummary}/>
        <meta name="twitter:image" content={seoBaseUrl + props.image}/>
        <meta name="twitter:image:src" content={seoBaseUrl + props.image}/>
        <meta name="twitter:image:alt" content={props.imageAlt}/>


        <script type="application/ld+json">{`{
                    "@context": "http://schema.org",
                    "@type": "NewsArticle",
                    "image": {
                            "@type": "ImageObject",
                            "width": 1920,
                            "height": 1191,
                            "url": "${seoBaseUrl + props.image}"
                    },
                    "url": "${seoBaseUrl + props.relativePath}",
                    "dateCreated": "${props.date}",
                    "datePublished": "${props.date}",
                    "dateModified": "${props.date}",
                    "headline": "${props.header}",
                    "name": "${props.header}",
                    "thumbnailUrl": "${seoBaseUrl + props.image}",
                    "keywords": ["${props.tags.map(function(tag){return "Tag:"+tag}).concat(props.tags.map(function(tag){return "Topic:"+tag})).concat(["Publication:envimate"]).join(",")}"],
                    "author": {
                    "@type": "Person",
                    "name": "${props.author}",
                    "url": "https://twitter.com/@${props.author}"
            },
                    "creator": [
                    "${props.author}"
                    ],
                    "publisher": {
                    "@type": "Organization",
                    "name": "envimate",
                    "url": "https://blog.envimate.com",
                    "logo": {
                    "@type": "ImageObject",
                    "width": 256,
                    "height": 256,
                    "url": "${seoBaseUrl + props.image}"
            }
            },
                    "mainEntityOfPage": "${seoBaseUrl + props.relativePath}"
            }`}</script>


    </Helmet>
);

MainHelmet.propTypes = {
    image: PropTypes.string.isRequired,
    imageAlt: PropTypes.string.isRequired
};

SingleArticleHelmet.propTypes = {
    header: PropTypes.string.isRequired,
    author: PropTypes.string.isRequired,
    relativePath: PropTypes.string.isRequired,
    imageAlt: PropTypes.string.isRequired,
    summary: PropTypes.string.isRequired,
    shortSummary: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    readTime: PropTypes.string.isRequired,
    date: PropTypes.string.isRequired,
};

export {MainHelmet, SingleArticleHelmet}

